<div class="bg-black min-h-[280px] flex p-4 gap-4 flex-wrap" style="background-image: linear-gradient(rgba(35,35,35,0.5), rgba(35,35,35,0.5)), url('https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/mainServices/ecosentino.png'); background-size: cover;">
    <div class="gap-4 flex flex-col justify-between flex-1 min-w-0">
        <div class="flex flex-col">
            <img src="{{ environment.publicUrl }}/assets/images/home/ecosentino-white.svg" alt="e.Cosentino" class="max-w-[180px]" />
            <span class="mt-2" style="color: white">{{ 'home.buy_product_ecosentino' | translate }}</span>
        </div>
        <app-button [primary]="true" size="l" class="w-full" (click)="goToECosentino()" [disabled]="disabled()">
            <span>{{ 'sidebar.access_e_cosentino' | translate }}</span>
        </app-button>
    </div>
</div>